import BarAndLine from 'd3vue/components/BarAndLine.vue'
import { keepDimensions, floatVal } from '../dataFilter'
import { toArray } from '../colors'
import api from '../api'

export default {
  id: 'bar-and-line',
  label: 'Graphique combiné barre et courbe',
  component: BarAndLine,
  dimensions: 1,
  multipleMeasure: () => true,
  adaptater: (data, vue) => {
    if (!vue.measure.length || vue.measure.length < 2) {
      vue.buildProps()
      return []
    }
    const props = {
      y2Formatter: vue.buildMeasureFormatter(api.measure.uniqueName(vue.metadata.measures[1])),
      barTitle: api.measure.name(vue.metadata.measures[0]),
      lineTitle: api.measure.name(vue.metadata.measures[1])
    }
    if (vue.colorScheme) {
      const colors = toArray(vue.colorScheme)
      props.lineColor = colors[0]
      props.barColor = colors[colors.length - 1]
    }
    vue.buildProps(props)
    return keepDimensions(1, data).map(d => {
      return {
        data: d,
        x: d.Group0Caption,
        y1: floatVal(d, api.measure.name(vue.measure[0])),
        y2: floatVal(d, api.measure.name(vue.measure[1]))
      }
    }).filter(d => !vue.noEmpty || d.y1 || d.y2)
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/BarAndLine.js